(function () {
    'use strict';

    angular.module("imApp").factory("selectPortalUserService", ['$ihttp', function ($ihttp) {
        let service = {
            listPortalUsers: function (parms) {
                return $ihttp.post({
                    method: 95,
                    parameters: parms || {}
                });
            },
            saveItem: function (item) {
                return $ihttp.post({
                    method: 96,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
